export const SuccessIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.47815 11.0511L4.6519 15.2824C4.85815 15.4911 5.14065 15.6061 5.43315 15.5986C5.72565 15.5924 6.00315 15.4649 6.1994 15.2461L14.3232 6.19613C14.7144 5.75988 14.6782 5.08738 14.2419 4.69488C13.8057 4.30363 13.1332 4.33988 12.7419 4.77613L5.3719 12.9874L1.99065 9.55863C1.5794 9.14113 0.90565 9.13613 0.48815 9.54738C0.0706504 9.95988 0.0656504 10.6324 0.47815 11.0511ZM10.6644 12.8911L9.24315 14.4761L10.0344 15.2786C10.2407 15.4874 10.5232 15.6011 10.8157 15.5949C11.1094 15.5874 11.3857 15.4599 11.5819 15.2424L19.7057 6.19113C20.0969 5.75488 20.0607 5.08238 19.6244 4.69113C19.1882 4.29863 18.5156 4.33488 18.1244 4.77238L10.7544 12.9824L10.6644 12.8911Z"
                fill="currentColor"
            />
        </svg>
    );
};
